export const LOADING_CHANGE = 'LOADING_CHANGE';
export const COLLAPSED_CHANGE = 'COLLAPSED_CHANGE';
export const ERROR_APP = 'ERROR_APP';
export const INFO_RESPONDENT_PUBLIC = 'INFO_RESPONDENT_PUBLIC';
export const SHOW_MODAL_SUBSCRIPTION = 'SHOW_MODAL_SUBSCRIPTION';
export const COLLAPSED_HEADER_CHANGE = 'COLLAPSED_HEADER_CHANGE';
export const LANGUAGE = 'LANGUAGE';
export const TOKEN = 'TOKEN';

/**
 * This function returns an object with a type property of LOADING_CHANGE.
 * @returns An object with a type property.
 */
const onChangeLoading = () => {
	return {
		type: LOADING_CHANGE
	}
} 


const onChangeModalSubscription = () => {
	return {
		type: SHOW_MODAL_SUBSCRIPTION
	}
}

/**
 * It returns an object with a type property.
 * @returns An object with a type property.
 */
const onChangeCollapsed = () => {
    return {
        type: COLLAPSED_CHANGE 
    }
}
/**
 * It returns an object with a type property.
 * @returns An object with a type property.
 */
const onChangeCollapsedHeader = () => {
    return {
        type: COLLAPSED_HEADER_CHANGE
    }
}

/**
 * This function returns an object with a type property and a content property.
 * @param content - the error message
 * @returns An object with a type and content property.
 */
const onErrorApp = (content) => {
	return {
		type: ERROR_APP,
		content
	}
}


const onGetInfoRespondentPublic = (content) => {
	return {
		type: INFO_RESPONDENT_PUBLIC,
		infoRespondent: content
	}
}
/**
 * Change language the app
 * @returns {{type: string}}
 */
const onChangeLanguage = (data) => {
	data = data === 'en' || data === 'es' ? data : 'en';
	localStorage.setItem('translationMKT' , data);
	return {
		type: LANGUAGE,
		data
	}
}

const refreshToken = (token) => {
	return {
		type: TOKEN,
		token
	}
}


export {
    onChangeLoading,
    onChangeCollapsed,
    onErrorApp,
	onGetInfoRespondentPublic,
	onChangeModalSubscription,
	onChangeCollapsedHeader,
	onChangeLanguage,
	refreshToken
}
